import React from 'react'

function Icon({ fill = '#D16643' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="85"
      viewBox="0 0 86 85"
      fill="none"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M84.41 42.34a41.08 41.08 0 11-82.161 0 41.08 41.08 0 0182.161 0zM42.62 72.08V32.86"
      ></path>
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.72"
        d="M48.56 62.42l7.84-1.77a4.026 4.026 0 10-1.4-7.93l-5.79.81a1.73 1.73 0 01-2-1.28c-.38-1.58 1.54-1.92 1.54-1.92l11.69-2.77A4.025 4.025 0 1059 39.64L49.21 41s-1.7.34-2-.93c-.3-1.27 1.5-1.67 1.5-1.67l7.7-1.87A4.042 4.042 0 1055 28.57l-5.79.81s-1.67.29-2-1.22c-.33-1.51 1.66-1.82 1.66-1.82l3.52-.92a4.018 4.018 0 003.265-4.655A4.022 4.022 0 0051 17.5l-4.33.55v-.58a4 4 0 10-8 0v.58l-4.33-.55a4.025 4.025 0 10-1.4 7.93l3.5 1s1.82.57 1.56 1.73a1.61 1.61 0 01-2 1.22l-5.77-.81a4.025 4.025 0 10-1.4 7.93l7.51 1.82s2 .15 1.67 1.62c-.33 1.47-2 1-2 1l-9.8-1.32a4.027 4.027 0 00-1.4 7.93l11.64 2.75s1.94.34 1.57 2a1.671 1.671 0 01-2 1.26l-5.77-.81a4.027 4.027 0 00-1.4 7.93l12.23 2.76"
      ></path>
    </svg>
  )
}

export default Icon
